import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { IngestingIcon } from "../../../components/icons";
import { useTranslation } from "react-i18next";
import { Box, Tooltip, Typography, CircularProgress } from "@mzc-pdc/ui";
import { alpha } from "@mui/material";
import theme from "@styles/theme";

export const AssetStatusArchiving = ({ containerType }) => {
    const { t } = useTranslation();

    return (
        <Box
            className={clsx(`${containerType}-status`, `${containerType}-status-archiving`)}
            sx={{
                position: `absolute`,
                left: 0,
                top: 0,
                zIndex: 1,
                width: `100%`,
                height: `100%`,
                display: `flex`,
                flexDirection: `column`,
                alignItems: `center`,
                justifyContent: `center`,
                backgroundColor: alpha(theme.palette.secondary[50], 0.9),
            }}
        >
            <Tooltip
                open={true}
                color={"warning"}
                title={
                    <Typography variant={"body3_700"} textTransform={"uppercase"}>
                        {t(`common::label::Archiving...`, `Archiving...`)}
                    </Typography>
                }
            >
                <CircularProgress color="warning" size={16} />
            </Tooltip>
        </Box>
    );
};
AssetStatusArchiving.propTypes = {
    containerType: PropTypes.oneOf(["card", "list"]).isRequired,
};
AssetStatusArchiving.defaultProps = {
    containerType: "card",
};

export default React.memo(AssetStatusArchiving);
